import http from "utils/http";

const apiOrigin = process.env.NODE_ENV === "development" ? "" : window.origin;

const apiBaseURL = apiOrigin + "/upgrade/v1";


/**
 * 查询插件信息
 * @param {Number} pageSize 页面容量
 * @param {Number} page 当前页
 * @param {Object} filter info,install_path,name
 */
export function queryPluginInfo(pageSize = 10, page = 0, filter) {
  return http.post(`${apiBaseURL}/plugin/query`, {
    page_size: pageSize,
    page: page,
    filter,
  });
}

// 登录
export function login(userName, password) {
  return http.post(`${apiBaseURL}/auth/login`, {
    username: userName,
    password,
  });
}

// 退出
export function logout(authorization) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.post(`${apiBaseURL}/auth/logout`, {}, config);
}

// 添加插件
export function addPlugin(
  authorization,
  { appId, module, installPath, info, aliasName }
) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.post(
    `${apiBaseURL}/plugin/add`,
    {
      app_id: appId,
      module,
      install_path: installPath,
      info,
      alias_name: aliasName,
    },
    config
  );
}

export function deletePlugin(authorization, appId) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.httpDelete(`${apiBaseURL}/plugin/del/${appId}`, config);
}

export function updatePlugin(
  authorization,
  { appId, newAppId, module, installPath, info, aliasName }
) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.put(
    `${apiBaseURL}/plugin/update/${appId}`,
    {
      app_id: newAppId,
      module,
      install_path: installPath,
      info,
      alias_name: aliasName,
    },
    config
  );
}

// 查询插件版本
export function queryPluginVer(pageSize = 30, page = 0, filter) {
  return http.post(`${apiBaseURL}/pluginVersion/query`, {
    page_size: pageSize,
    page: page,
    filter,
  });
}

// 添加插件版本
export function addPluginVer(
  authorization,
  {
    pluginAppId,
    fileId,
    buildTime,
    changeInfo,
    publishFlag,
    version,
    pluginVerHash,
    publishSystem,
  }
) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.post(
    `${apiBaseURL}/pluginVersion/add`,
    {
      plugin_app_id: pluginAppId,
      file_id: fileId,
      build_time: buildTime,
      plugin_ver_hash: pluginVerHash,
      change_info: changeInfo,
      version,
      publish_flag: publishFlag,
      system: publishSystem,
    },
    config
  );
}

// 修改插件版本
export function updatePluginVer(
  authorization,
  id,
  fileId,
  buildTime,
  changeInfo,
  changeInfoEn,
  version,
  publishFlag,
  pluginVerHash,
  publishSystem
) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.put(
    `${apiBaseURL}/pluginVersion/update/${id}`,
    {
      file_id: fileId,
      build_time: buildTime,
      change_info: changeInfo,
      change_info_en: changeInfoEn,
      version,
      publish_flag: publishFlag,
      plugin_ver_hash: pluginVerHash,
      system: publishSystem,
    },
    config
  );
}

export function deletePluginVer(authorization, id) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.httpDelete(`${apiBaseURL}/pluginVersion/del/${id}`, config);
}

// 添加插件版本依赖
export function addPluginVerDep(authorization, plugVerId, depPlugVerId) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.post(
    `${apiBaseURL}/pluginDep/add/${plugVerId}/${depPlugVerId}`,
    {},
    config
  );
}

// 删除插件版本依赖
export function deletePluginVerDep(authorization, plugVerId, depPlugVerId) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.httpDelete(
    `${apiBaseURL}/pluginDep/del/${plugVerId}/${depPlugVerId}`,
    config
  );
}

// 上传文件
export function uploadFile(authorization, file, cancelToken, onUpload = (percent, loaded, total) => {}) {
  let formData = new FormData();
  formData.append("upload", file);
  return http.post(`${apiBaseURL}/file/upload`, formData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: authorization,
    },
    cancelToken,
    onUploadProgress: function (e) {
      const { loaded, total } = e;
      let percent = Math.floor((loaded / total) * 100 * 100) / 100;
      console.log(loaded, "/", total, percent);
      onUpload && onUpload(percent, loaded, total)
    },
  });
}

// 下载文件
export function downloadFile(fileId) {
  return http.get(
    `${apiBaseURL}/file/download/${fileId}`,
    {},
    {
      // axios请求里必须修改 responseType: 'blob' 参数, 默认是json。否则axios自动使用UTF8编码，会破坏数据
      responseType: "blob",
    }
  );
}

// 下载文件的url
export function getDownloadFileUrl(fileId, host) {
  // return `http://192.168.88.25:9999/upgrade/v1/file/download/${fileId}`;
  return `${apiBaseURL}/file/download/${fileId}`;
}

// 删除文件
export function deleteFile(authorization, fileId) {
  const config = {
    headers: { Authorization: authorization },
  };
  return http.httpDelete(`${apiBaseURL}/file/delete/${fileId}`, config);
}

// 版本发布的文件上传 接受参数是一个要上传的文件
export function uploadVersionFile(authorization,file) {
  const formData = new FormData()
  formData.append('upload',file)
  return http.post(
    `${apiBaseURL}/file/upload`,
    formData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization,
      },
    }
  )
}

// 根据转换之后的file_id上传版本到服务器,需要的参数(build_time,change_info,file_id,plugin_app_id,publish_flag,version,plugin_ver_hash)
const uploadVersion = (authorization,json_info,file_id) => {
  return http.post(
    `${apiBaseURL}/pluginVersion/add`,
    {
      ...json_info,
      plugin_app_id:json_info.app_id,
      file_id,
      plugin_ver_hash:json_info.file_hash,
      // 默认就是发正式版本，不能发测试版本
      publish_flag: 1,
      system:json_info.os_version
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization
      }
    }
  )
}

// 查询没有发布版本的插件
const queryPluginNoVer = (authorization) => {
  return http.get(
    `${apiBaseURL}/plugin/getNoVersionRecordList`,{},{
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization
      }
    }
  )
}

// 查询过期插件版本列表
const getOvertimePluginVer = (authorization,reserveCount) => {
  return http.get(
    `${apiBaseURL}/pluginVersion/getExpireVersionList`,{ reserveCount },{
      headers: {
        "Content-Type": "application/json",
        Authorization: authorization
      }
    }
  )
}

// const getHistoryVer = () => {
//   return http.post(
//     `${apiBaseURL}/pluginVersion/query`,
//     {
//       page_size: 50,
//       page: 0
//     }
//   )
// }

const api = {
  apiBaseURL,
  queryPluginInfo,
  login,
  logout,
  addPlugin,
  deletePlugin,
  updatePlugin,
  queryPluginVer,
  addPluginVer,
  updatePluginVer,
  deletePluginVer,
  addPluginVerDep,
  deletePluginVerDep,
  uploadFile,
  downloadFile,
  getDownloadFileUrl,
  deleteFile,
  uploadVersionFile,
  uploadVersion,
  queryPluginNoVer,
  getOvertimePluginVer
  // getHistoryVer
};

export default api;
